// extracted by mini-css-extract-plugin
export default {"icon":"LangSelector_icon__tphGp","dropdown_wrapper":"LangSelector_dropdown_wrapper__wTLKX","user_icon":"LangSelector_user_icon__xChtc","user_name":"LangSelector_user_name__DYUUh"};